<template>
  <div>
    <div class="header">
      <div class="title">
        <span class="Ben">Vs竞店</span>
        <span class="Jing TitActive">Vs本店</span>
      </div>
    </div>
     <Ben></Ben>
  </div>
</template>
<script>
import Ben from './VsBen/VsBen';

export default {
  data(){
    return {}
  },
  components:{
    Ben
  }
}
</script>
<style scoped>
.header {
  position: relative;
  padding-top: 35px;
  top: 0;
  z-index: 99;
  background: rgb(224, 68, 60);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.title {
  display: flex;
  align-items: center;
  height: 30px;
  line-height: 30px;
  width: 90%;
  margin: 0px auto 20px;
  border-radius: 10px;
  border: 1px solid #ccc;
  color: #ccc;
}
.title > span {
  text-align: center;
  display: inline-block;
  width: 50%;
  height: 100%;
  border-radius: 10px;
}
.TitActive {
  background-color: #fff;
  color: rgb(224, 68, 60);
}
</style>


// WEBPACK FOOTER //
// src/components/ButSix_vs/VsIndex.vue